export default __webpack_public_path__ + "static/media/aws_icon_146074.de8c5d7d.png";